import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QuestionType } from '../question-type';
import { Question } from './question';
import { Result, UniqueEntityID } from '@digibricks/core';
import { SingleChoiceQuestion } from './single-choice-question';
import { MultipleChoiceQuestion } from './multiple-choice-question';
import { FillInBlankQuestion } from './fill-in-blank-question';
import { MatchingQuestion } from './matching-question';
import { EssayQuestion } from './essay-question';
import { TimeUnit } from '../time-unit';
import { SpeakingMaxAttempts } from './speaking-max-attempts';
import { SpeakingMinAnswerDuration } from './speaking-min-answer-duration';
import { DEFAULT_SPEAKING_SETTINGS } from './speaking-settings';
export var SpeakingQuestion = /*#__PURE__*/function (_Question) {
  _inherits(SpeakingQuestion, _Question);

  var _super = _createSuper(SpeakingQuestion);

  function SpeakingQuestion() {
    _classCallCheck(this, SpeakingQuestion);

    return _super.apply(this, arguments);
  }

  _createClass(SpeakingQuestion, [{
    key: "speakingSettings",
    get: function get() {
      return this.props.speakingSettings;
    }
  }, {
    key: "updateSpeakingSettings",
    value: function updateSpeakingSettings(settings) {
      this.props.speakingSettings = SpeakingQuestion.withDefaultSettings(_objectSpread(_objectSpread({}, this.speakingSettings), settings));
      return Result.ok();
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      var settings = this.speakingSettings;
      var preparationTime = TimeUnit.toTotalSeconds(settings.preparationTime, settings.preparationTimeUnit);
      var speakingTime = TimeUnit.toTotalSeconds(settings.speakingTime, settings.speakingTimeUnit);
      var minAnswerDuration = SpeakingMinAnswerDuration.isUnlimited(settings.minAnswerDuration) ? SpeakingMinAnswerDuration.Unlimited : TimeUnit.toTotalSeconds(settings.minAnswerDuration, settings.minAnswerDurationUnit);
      var maxAttempts = SpeakingMaxAttempts.isUnlimited(settings.maxAttempts) ? SpeakingMaxAttempts.Unlimited : settings.maxAttempts;
      return _objectSpread(_objectSpread({}, _get(_getPrototypeOf(SpeakingQuestion.prototype), "toJsonObject", this).call(this)), {}, {
        speakingSettings: {
          preparationTime: preparationTime,
          speakingTime: speakingTime,
          maxAttempts: maxAttempts,
          minAnswerDuration: minAnswerDuration
        }
      });
    }
  }, {
    key: "cloneExtendedProps",
    value: function cloneExtendedProps(question, newQuestionProps) {
      switch (newQuestionProps.type) {
        case QuestionType.SingleChoice:
          return SingleChoiceQuestion.createDefault(newQuestionProps);

        case QuestionType.MultipleChoice:
          return MultipleChoiceQuestion.createDefault(newQuestionProps);

        case QuestionType.FillInBlank:
          return FillInBlankQuestion.createDefault(newQuestionProps);

        case QuestionType.Matching:
          return MatchingQuestion.createDefault(newQuestionProps);

        case QuestionType.Essay:
          return EssayQuestion.create(newQuestionProps);

        case QuestionType.Speaking:
          {
            var speakingQuestion = question;
            var speakingProps = newQuestionProps;
            speakingProps.speakingSettings = speakingQuestion.speakingSettings;
            return SpeakingQuestion.create(speakingProps);
          }

        default:
          return Result.fail('Invalid question type');
      }
    }
  }], [{
    key: "withDefaultSettings",
    value: function withDefaultSettings(settings) {
      var _settings$preparation, _settings$preparation2, _settings$speakingTim, _settings$speakingTim2, _settings$maxAttempts, _settings$minAnswerDu, _settings$minAnswerDu2;

      return {
        preparationTime: (_settings$preparation = settings === null || settings === void 0 ? void 0 : settings.preparationTime) !== null && _settings$preparation !== void 0 ? _settings$preparation : DEFAULT_SPEAKING_SETTINGS.preparationTime,
        preparationTimeUnit: (_settings$preparation2 = settings === null || settings === void 0 ? void 0 : settings.preparationTimeUnit) !== null && _settings$preparation2 !== void 0 ? _settings$preparation2 : DEFAULT_SPEAKING_SETTINGS.preparationTimeUnit,
        speakingTime: (_settings$speakingTim = settings === null || settings === void 0 ? void 0 : settings.speakingTime) !== null && _settings$speakingTim !== void 0 ? _settings$speakingTim : DEFAULT_SPEAKING_SETTINGS.speakingTime,
        speakingTimeUnit: (_settings$speakingTim2 = settings === null || settings === void 0 ? void 0 : settings.speakingTimeUnit) !== null && _settings$speakingTim2 !== void 0 ? _settings$speakingTim2 : DEFAULT_SPEAKING_SETTINGS.speakingTimeUnit,
        maxAttempts: (_settings$maxAttempts = settings === null || settings === void 0 ? void 0 : settings.maxAttempts) !== null && _settings$maxAttempts !== void 0 ? _settings$maxAttempts : DEFAULT_SPEAKING_SETTINGS.maxAttempts,
        minAnswerDuration: (_settings$minAnswerDu = settings === null || settings === void 0 ? void 0 : settings.minAnswerDuration) !== null && _settings$minAnswerDu !== void 0 ? _settings$minAnswerDu : DEFAULT_SPEAKING_SETTINGS.minAnswerDuration,
        minAnswerDurationUnit: (_settings$minAnswerDu2 = settings === null || settings === void 0 ? void 0 : settings.minAnswerDurationUnit) !== null && _settings$minAnswerDu2 !== void 0 ? _settings$minAnswerDu2 : DEFAULT_SPEAKING_SETTINGS.minAnswerDurationUnit
      };
    }
  }, {
    key: "create",
    value: function create(props, id) {
      var basePropsOrError = _get(_getPrototypeOf(SpeakingQuestion), "createBaseProps", this).call(this, props);

      if (basePropsOrError.isFailure) {
        return Result.fail(basePropsOrError.error);
      }

      var defaultProps = _objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
        type: QuestionType.Speaking,
        speakingSettings: this.withDefaultSettings(props.speakingSettings)
      });

      return Result.ok(new SpeakingQuestion(defaultProps, id || new UniqueEntityID(props.id)));
    }
  }, {
    key: "createDefault",
    value: function createDefault(props) {
      return SpeakingQuestion.create(_objectSpread(_objectSpread({}, props), {}, {
        type: QuestionType.Speaking
      }));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var _speakingSettings$pre, _speakingSettings$spe, _speakingSettings$max, _speakingSettings$min, _data$constraints;

        var basePropsOrError = _get(_getPrototypeOf(SpeakingQuestion), "fromJsonBase", this).call(this, data);

        if (basePropsOrError.isFailure) {
          return Result.fail(basePropsOrError.error);
        }

        var speakingSettings = data.speakingSettings;
        var preparationTime = (_speakingSettings$pre = speakingSettings === null || speakingSettings === void 0 ? void 0 : speakingSettings.preparationTime) !== null && _speakingSettings$pre !== void 0 ? _speakingSettings$pre : data.preparationTime;
        var speakingTime = (_speakingSettings$spe = speakingSettings === null || speakingSettings === void 0 ? void 0 : speakingSettings.speakingTime) !== null && _speakingSettings$spe !== void 0 ? _speakingSettings$spe : data.speakingTime;
        var maxAttempts = (_speakingSettings$max = speakingSettings === null || speakingSettings === void 0 ? void 0 : speakingSettings.maxAttempts) !== null && _speakingSettings$max !== void 0 ? _speakingSettings$max : data.maxAttempts;
        var minAnswerDuration = (_speakingSettings$min = speakingSettings === null || speakingSettings === void 0 ? void 0 : speakingSettings.minAnswerDuration) !== null && _speakingSettings$min !== void 0 ? _speakingSettings$min : (_data$constraints = data.constraints) === null || _data$constraints === void 0 ? void 0 : _data$constraints.minAnswerDuration;
        return this.create(_objectSpread(_objectSpread({}, basePropsOrError.getValue()), {}, {
          speakingSettings: {
            preparationTime: preparationTime,
            preparationTimeUnit: speakingSettings === null || speakingSettings === void 0 ? void 0 : speakingSettings.preparationTimeUnit,
            speakingTime: speakingTime,
            speakingTimeUnit: speakingSettings === null || speakingSettings === void 0 ? void 0 : speakingSettings.speakingTimeUnit,
            maxAttempts: maxAttempts,
            minAnswerDuration: minAnswerDuration,
            minAnswerDurationUnit: speakingSettings === null || speakingSettings === void 0 ? void 0 : speakingSettings.minAnswerDurationUnit
          }
        }));
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return SpeakingQuestion;
}(Question);